<template>
  <div class="sm-customers-table__popup">
    <h4>Fast mail entry</h4>
    <input-number
      v-model="quantity"
      :min="1"
      :label="'Mail items quantity'"
      :showControls="false"
    />
    <btn-block
      :type="'button'"
      :text="`Add mail and notify ${provider.client_level != 1 ? 'customer' : 'user'}`"
      @click="addMail"
    />
  </div>
</template>

<script>
import InputNumber from '@/components/InputNumber';
import { mapGetters } from 'vuex';

export default {
  name: 'quick-mail',
  components: { 
    'input-number': InputNumber 
  },
  props: {
    pmb: {
      required: true
    }
  },
  data() {
    return {
      quantity: 1
    }
  },
  computed: {
    ...mapGetters({
      provider: 'provider'
    })
  },
  methods: {
    addMail() {
      this.$emit('add', {
        pmb: this.pmb,
        quantity: this.quantity
      })
    }
  }
}
</script>

